import styled from 'styled-components';

import { ReactComponent as EnvironmentSvg } from '../../assets/EnvSelectorIcon.svg';

export const EnvironmentSelectorIcon = styled(EnvironmentSvg)`
  width: 48px;
  height: 48px;
`;

export const EnvironmentIconContainer = styled.div`
  width: 64px;
  height: 64px;
  position: relative;
  display: flex;
  align-items: center;
  justify-content: center;
  cursor: pointer;
`;

export const EnvironmentIcon = styled.span`
  position: absolute;
  font-size: 10px;
  font-weight: bold;
  left: 16px;
  bottom: 32px;
`;